/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleselfcontrolstrong4Inputs */



/**
* | output |
* | --- |
* | "You know how to regulate your emotions and often use that skill to find solutions in personal situations." |
*
* @param {Eisubscaleselfcontrolstrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleselfcontrolstrong4 = /** @type {((inputs?: Eisubscaleselfcontrolstrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleselfcontrolstrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You know how to regulate your emotions and often use that skill to find solutions in personal situations.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sabes regular tus emociones y sueles usar esa habilidad para encontrar soluciones en situaciones personales.")
	return /** @type {LocalizedString} */ ("Ты умеешь регулировать свои эмоции и нередко используешь этот навык, чтобы находить решения в личных ситуациях.")
});
export { eisubscaleselfcontrolstrong4 as "eiSubscaleSelfControlStrong" }